import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
}

export default function SectionHeading({ kicker, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="flex items-center gap-2">
          <span className="h-[3px] w-6 rounded-full bg-accent-500" />
          <span className="label-caps text-[11px] text-accent-700">{kicker}</span>
        </div>
        <h2 className="mt-3 text-xl font-bold tracking-tight text-foreground-950 md:text-[26px]">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">{description}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="group inline-flex items-center gap-1.5 self-start whitespace-nowrap text-sm font-medium text-primary-600 hover:text-accent-600 transition-colors sm:self-auto cursor-pointer"
        >
          {action.label}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}